import { Config as ConfigType } from './types';
import { user } from './rhco/user';
import { expert } from './rhco/expert';
import { client } from './rhco/client';
import { company } from './rhco/company';
import { mission } from './rhco/mission';
import { invitation } from './rhco/invitation';
import { candidate } from './rhco/candidate';
import { candidacy } from './rhco/candidacy';
import { proposal } from './rhco/proposal';
import { quotation } from './rhco/quotation';
import { charge } from './rhco/charge';
import { milestone } from './rhco/milestone';
import { contract } from './rhco/contract';
import { contractMilestone } from './rhco/contractMilestone';
import { invoice } from './rhco/invoice';
import { recommendation } from './rhco/recommendation';
import { legalInformation } from './rhco/legalInformation';
import { cgu } from './rhco/cgu';
import { match } from './rhco/match';
import { document } from './rhco/document';
import { subCategory } from './rhco/subCategory';
import { documentFile } from './rhco/documentFile';
import { documentsCompanies } from './rhco/documentsCompanies';
import { tag } from './rhco/tag';
import { clientInvoice } from './rhco/clientInvoice';
import { expertInvoice } from './rhco/expertInvoice';
import { payments } from './rhco/payments';
import { creditNotes } from './rhco/creditNote';

export const config: ConfigType = {
  login: 'password',
  hash: '4rr0tdosatvzb70almrhxtkbk',
  locale: 'fr',
  name: 'rhco',
  dashboard: false,
  theme: {
    primary: '#0C073C',
    secondary: '#364CBB',
    info: '#f8dddd',
  },
  defaultCountry: 'fr',
  preferredCountries: ['fr', 'ma', 'ch', 'tn'],
  invoiceUploadedByUser: true,
  resources: [
    expert,
    client,
    user,
    subCategory,
    company,
    mission,
    invitation,
    candidate,
    candidacy,
    proposal,
    quotation,
    charge,
    milestone,
    contract,
    contractMilestone,
    invoice,
    creditNotes,
    recommendation,
    legalInformation,
    document,
    documentFile,
    documentsCompanies,
    cgu,
    match,
    tag,
    expertInvoice,
    clientInvoice,
    payments,
  ],
};

export default config;
